export enum TableHeaderNamesConstants {
  REFERENCE = 'ref',
  ENUMBER = 'eNumber',
  DESCRIPTION = 'description',
  UNIT_PRICE = 'price',
  TOTAL_PRICE = 'totalPrice',
  PREWIRING = 'deliverToPanelBuilder',
  DIRECT_DELIVERY = 'deliverToCustomer',
  QUANTITY = 'quantity',
  LAST_MODIFIED = 'lastModified',
  FAVOURITE = 'isFavorite',
  PROJECT_NAME = 'projectName',
  CREATED = 'created',
  FIRST_NAME = 'clientFirstName',
  CITY = 'clientCity',
  PHONE = 'phoneNumber',
  OWNER = 'owner',
  STOCK_LEVEL = 'stockLevel'
}
